import type { Editor } from "@tiptap/core";
import { NodeViewContent, NodeViewWrapper } from "@tiptap/react";
import type { NodeViewProps } from "@tiptap/react";
import type { KeyboardEvent } from "react";

import { useEditorReadOnly } from "./fields-context";

export const StepTitle = {
	focus(editor: Editor, pos: number) {
		const dom = editor.view.nodeDOM(pos);

		if (!(dom instanceof HTMLElement)) {
			return false;
		}

		const input = dom.querySelector("input");

		if (input === null) {
			return false;
		}

		input.focus();
		input.setSelectionRange(input.value.length, input.value.length);

		return true;
	},
};

export function StepView(props: NodeViewProps) {
	const readOnly = useEditorReadOnly();
	const handleTitleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
		if (event.key === "Enter" || event.key === "ArrowDown") {
			event.preventDefault();

			const pos = props.getPos();

			if (pos !== undefined) {
				props.editor.commands.focus(pos + 1);
			}

			return;
		}

		if (
			event.key === "Backspace" &&
			props.node.attrs.title === "" &&
			props.node.content.size === 0
		) {
			event.preventDefault();
			props.deleteNode();
			props.editor.commands.focus();
		}
	};

	return (
		<NodeViewWrapper className="step">
			<p className="step-title flex items-baseline gap-1">
				<input
					className="min-w-0 flex-1 bg-transparent font-semibold focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
					value={props.node.attrs.title}
					readOnly={readOnly}
					tabIndex={readOnly ? -1 : undefined}
					placeholder={readOnly ? undefined : "Título da etapa"}
					onChange={(event) => props.updateAttributes({ title: event.target.value })}
					onKeyDown={handleTitleKeyDown}
				/>
			</p>
			<NodeViewContent<"p"> as="p" />
		</NodeViewWrapper>
	);
}
